export default __webpack_public_path__ + "614e402d4faf3631363eb1d5b39d9c5b.svg";